import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from 'auth';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const toastr = inject(ToastrService);

  const denyUnauthorized = (): boolean => {
    toastr.error('You are not authorized to access this page');
    router.navigate(['/login']);
    return false;
  };

  if (authService.isLoggedIn()) {
    return authService.getUserRole().includes('Vendor') ? true : denyUnauthorized();
  }

  // Token is missing or expired. If a refresh token is still on hand, try a
  // silent refresh before bouncing to /login.
  if (!authService.getRefreshToken()) {
    return denyUnauthorized();
  }

  return authService.getRefreshedToken().pipe(
    map(() => (authService.getUserRole().includes('Vendor') ? true : denyUnauthorized())),
    catchError((refreshErr) => {
      if (authService.isInvalidRefreshTokenError(refreshErr)) {
        authService.clearTokens();
        toastr.error('Your session has expired. Please log in again.');
        router.navigate(['/login']);
      } else {
        toastr.error('Network error. Please check your connection and try again.');
      }
      return of(false);
    }),
  );
};
